import styleInject from '../../external/style-inject/dist/style-inject.es.js';

var css_248z = ".CarLoader-module_loader__ZaeuU {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  max-width: 400px;\n  padding: 0;\n}\n\n.CarLoader-module_title__g8c1d {\n  margin-bottom: 48px;\n  font-size: 2.125rem;\n  font-weight: 700;\n  text-align: center;\n}\n\n.CarLoader-module_subtitle__btqlp {\n  margin-top: 40px;\n  font-size: 1.125rem;\n  font-weight: normal;\n}";
var styles = {"loader":"CarLoader-module_loader__ZaeuU","title":"CarLoader-module_title__g8c1d","subtitle":"CarLoader-module_subtitle__btqlp"};
styleInject(css_248z);

export { styles as default };
